import { useQuery } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import { GET_IN_APP_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { CURRENCY } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { GET_PRODUCTS_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
import { FIND_PURCHASE_OPTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/purchase/options/rpc/PurchaseOptionsService.dfc.new';
export const useBestRecurringTermDiscountedPriceDueUponPurchase = ({
  productApiName
}) => {
  var _productDetailsQuery$, _currencyQuery$data, _productDetailsQuery$2, _currencyQuery$data2, _purchaseOptionsQuery, _purchaseOptionsQuery2;
  const currencyQuery = useQuery(GET_IN_APP_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY
    }
  });
  const productDetailsQuery = useQuery(GET_PRODUCTS_QUERY, {
    variables: {
      productApiNames: [productApiName]
    }
  });
  const purchaseOptionsProducts = !((_productDetailsQuery$ = productDetailsQuery.data) !== null && _productDetailsQuery$ !== void 0 && _productDetailsQuery$.result) ? [] : [{
    skuUuid: productDetailsQuery.data.result.productsByName[productApiName].skuUuid,
    quantity: 1
  }];
  const purchaseOptionsQuery = useQuery(FIND_PURCHASE_OPTIONS_QUERY, {
    variables: {
      userContext: {
        __typename: 'com.hubspot.purchase.options.models.rpc.context.TouchlessUserContext',
        currencyCode: (_currencyQuery$data = currencyQuery.data) === null || _currencyQuery$data === void 0 ? void 0 : _currencyQuery$data.currencies.defaultCurrencyCode,
        language: getLang().toUpperCase()
      },
      products: !((_productDetailsQuery$2 = productDetailsQuery.data) !== null && _productDetailsQuery$2 !== void 0 && _productDetailsQuery$2.result) ? [] : [{
        skuUuid: productDetailsQuery.data.result.productsByName[productApiName].skuUuid,
        quantity: 1
      }]
    },
    skip: purchaseOptionsProducts.length === 0 || !((_currencyQuery$data2 = currencyQuery.data) !== null && _currencyQuery$data2 !== void 0 && _currencyQuery$data2.currencies.defaultCurrencyCode)
  });
  return {
    error: purchaseOptionsQuery.error || productDetailsQuery.error || null,
    loading: purchaseOptionsQuery.loading || productDetailsQuery.loading || false,
    data: {
      price: (_purchaseOptionsQuery = purchaseOptionsQuery.data) !== null && _purchaseOptionsQuery !== void 0 && _purchaseOptionsQuery.result.purchaseOptions ? getMostAffordablePrice(purchaseOptionsQuery.data.result.purchaseOptions) : null,
      currencyCode: ((_purchaseOptionsQuery2 = purchaseOptionsQuery.data) === null || _purchaseOptionsQuery2 === void 0 ? void 0 : _purchaseOptionsQuery2.result.purchaseOptions[0].orderedTerms[0].recurringTermDiscountedPrice.currencyCode) || null
    }
  };
};
function getMostAffordablePrice(purchaseOptions) {
  if (purchaseOptions.length === 0) {
    return null;
  }
  const sortedOptions = [...purchaseOptions].sort((purchaseOptionA, purchaseOptionB) => {
    const priceA = Number(purchaseOptionA.orderedTerms[0].recurringTermDiscountedPrice.monthlyPrice);
    const priceB = Number(purchaseOptionB.orderedTerms[0].recurringTermDiscountedPrice.monthlyPrice);
    if (priceA < priceB) {
      return -1;
    }
    if (priceA > priceB) {
      return 1;
    }
    return 0;
  });
  return Number(sortedOptions[0].orderedTerms[0].recurringTermDiscountedPrice.monthlyPrice);
}